import AbsComponent from "../AbsComponent";

class AbsCategories extends AbsComponent {
    constructor(_name='', _store={}, _router={}, _el=''){
        super(_name, _store, _router, _el);

        let watchCategories = this.watch(this.store.getState, 'categories', this.isEqual);
        this.store.subscribe( watchCategories( (newVal, oldVal, path) => {
            this.render(newVal, oldVal, path);
            this.setActive();
            this.addEvents();
        } ) );

        this.subInit();
        this.store.dispatch( this.actions.loadCategories() );
    }

    subInit(){}
    setActive(){}
    addEvents(){}
    
    render(_newVal, _oldVal, _path){
        let list = _newVal.map( it => {
            let el = $(`
            <li data-categoryid="${it.id}" data-raceid="${it.id}">
                <button data-categoryid="${it.id}" data-raceid="${it.id}" class="gd-filter-list-link depth1">${it.name}</button>
            </li>`);
            
            let subList = [];
            if(it.sub.length){
                subList = it.sub.map( subIt => `
                <li data-categoryid="${subIt.id}" data-classid="${subIt.id}">
                    <button data-categoryid="${subIt.id}" data-classid="${subIt.id}" class="gd-filter-list-inner-link depth2">${subIt.name}</button>
                </li>`);
                $(`<ul class="gd-filter-list-inner"></ul>`).appendTo(el).append(subList);
            }
            return el;
        });

        $( this.el + ' .gd-filter-list' ).html(list);
    }






} // end of class
export default AbsCategories;